// src/components/menu/menu.js
import LogoImage from "../../assets/img/logo.png";
import Status from "../status/status";
import { getMenuButtons } from "../../config/menuConfig";
import "../../styles/desktop/menu.css";

// Componente para renderizar um botão individual
const MenuButton = ({ button, isActive, onClick, alertStatus = null }) => {
  const { 
    id, 
    label, 
    page,
    icon: Icon, 
    iconProps = {}, 
    customIcon, 
    isLocked, 
    lockIcon: LockIcon, 
    className = ""
  } = button;

  const handleClick = () => {
    if (!isLocked) {
      onClick(page);
    }
  };

  // Determina as props do ícone baseado no estado ativo
  const getIconProps = () => {
    if (iconProps.getDynamicProps) {
      return { ...iconProps, ...iconProps.getDynamicProps(isActive) };
    }
    return iconProps;
  };

  // Renderiza o ícone apropriado
  const renderIcon = () => {
    if (customIcon) {
      return customIcon(isActive);
    }
    
    if (Icon) {
      return <Icon {...getIconProps()} />;
    }
    
    return null;
  };

  // Classes CSS do botão (inclui classes de alerta para Monitoramento)
  const buttonClasses = [
    "btn",
    className,
    isActive ? "active" : "",
    isLocked ? "bloqueado" : "",
    // Adiciona classes de alerta apenas para o botão de Monitoramento
    page === "Monitoramento" && alertStatus ? `alert-${alertStatus}` : ""
  ].filter(Boolean).join(" ");

  return (
    <button
      key={id}
      className={buttonClasses}
      onClick={handleClick}
      disabled={isLocked}
      title={page === "Monitoramento" && alertStatus ? 
        `${alertStatus === 'fire' ? '🔥 Incêndio detectado!' : '⚠️ Falha detectada!'}` : 
        label
      }
    >
      {label}
      {renderIcon()}
      {/* Indicador visual de alerta para Monitoramento */}
      {page === "Monitoramento" && alertStatus && (
        <span className={`alert-indicator ${alertStatus}`}>
          {alertStatus === 'fire'}
        </span>
      )}
      {isLocked && LockIcon && (
        <span className="icon-cadeado">
          <LockIcon width="25" height="25" />
        </span>
      )}
    </button>
  );
};

// Componente principal do Menu
function Menu({ trocarPagina, paginaAtual, monitoramentoData = {} }) {
  const menuButtons = getMenuButtons();
  
  // Extrai apenas os dados necessários
  const {
    hasAlert = false,
    activeAlerts = []
  } = monitoramentoData;

  // Determina o status de alerta para o botão de Monitoramento
  const getMonitoringAlertStatus = () => {
    if (!hasAlert || activeAlerts.length === 0) {
      return null; // Sem alertas
    }
    
    // Prioridade: FIRE > FAULT > INFO
    if (activeAlerts.some(alert => alert.severity === 'FIRE')) {
      return 'fire';
    }
    if (activeAlerts.some(alert => alert.severity === 'FAULT')) {
      return 'fault';
    }
    return null; // INFO não gera alerta visual
  };

  const monitoringAlertStatus = getMonitoringAlertStatus();

  return (
    <nav className="menu">
      <div id="barraDeOpções">
        <img src={LogoImage} alt="Logo" id="logo" />
        <div id="barraDeOpções-Botoes">
          {menuButtons.map((button) => (
            <MenuButton
              key={button.id}
              button={button}
              isActive={paginaAtual === button.page}
              onClick={trocarPagina}
              alertStatus={button.page === "Monitoramento" ? monitoringAlertStatus : null}
            />
          ))}
        </div>
      </div>
      
      <div className="statusObject">
        <Status />
      </div>
    </nav>
  );
}

export default Menu;